import { render, staticRenderFns } from "./DialogRelate.vue?vue&type=template&id=417a9391&"
import script from "./DialogRelate.vue?vue&type=script&lang=js&"
export * from "./DialogRelate.vue?vue&type=script&lang=js&"
import style0 from "./DialogRelate.vue?vue&type=style&index=0&id=417a9391&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports